import { REGISTER_GOOGLE } from './../actions/AppHeaderAction';

const defaultState = {
    google: false
};

const appHeader = (state = defaultState, action) => {
    let newState;
    switch (action.type) {
        case REGISTER_GOOGLE:
            newState = {...state, google: true};
            break;
        default:
            newState = state;
            break
    }

    return newState;
};

export default appHeader;



// WEBPACK FOOTER //
// ./src/reducers/AppHeaderReducer.js